export const modalTypes = {
  SET_MODAL: 'MODAL_SET',
  REMOVE_MODAL: 'MODAL_REMOVE',
};
